import { useQuery } from "@tanstack/react-query";
import { groupBy } from "lodash";

import { ItemModel } from "api";
import { services } from "contexts/ServiceContext";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";

const itemToSelectOption = (item: ItemModel) => ({
  label: item.Name ?? "",
  value: item.Code ?? item.Name ?? "",
  uom: item.SaleUnitOfMeasureCode,
});

const useGetProductList = () => {
  const selectedCustomerCode = useSelectedCustomerCode()[0];
  return useQuery({
    queryKey: ["products", { selectedCustomerCode }],
    queryFn: () =>
      selectedCustomerCode
        ? services.itemService.getProductList(selectedCustomerCode)
        : Promise.reject(),
    enabled: !!selectedCustomerCode,
    select: ({ value }) =>
      Object.entries(groupBy(value, "CategoryName")).map(
        ([categoryName, categoryItems]) => ({
          label: categoryName,
          options: categoryItems.map(itemToSelectOption),
        })
      ),
  });
};

export default useGetProductList;
